/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import { Col, Row, Space, Image, message } from 'antd'
import { numberWithComma } from 'helpers/format'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { TableListPage } from 'Components/common/Table'
import ConfirmWithChild from 'Components/modal/ConfirmWithChild'
import { appConfig } from 'config'
import { ImageFallback } from 'helpers/constanst'
import { QuotationProduct, UpdateGrnReq } from 'Store/quotation/types'
import { ProductsGrn, SelectedProductsGrn } from 'Store/stock/types'
import GrnTransfer from 'Pages/Orders/components/GrnTransfer'
import _, { cloneDeep } from 'lodash'
import { ProductGrns } from 'Store/orders/types'
import { updateGrnQuotationAPI } from 'Store/quotation/api'
import { connect, useDispatch } from 'react-redux'
import { selectCurrentUser } from 'Store/user/selector'
import RootState from 'typings/RootState'
import { EventModal } from 'Components/modal'
import { selectGrnEvent } from 'Store/quotation/selector'
import { clearEventAction } from 'Store/quotation/actions'
import { OverstockTag } from 'Components/utilities'
import ProductUomSystemInfo from 'Pages/Product/components/ProductUomSystemInfo'

type Props = {
  visible: boolean
  onCloseModal: () => void
  onSuccess?: () => void
  products: QuotationProduct[]
  productsGrn: ProductsGrn[]
  id: number
} & ReduxProps

const ConfirmQuotation: React.FunctionComponent<Props> = props => {
  const {
    onCloseModal,
    visible,
    onSuccess = () => {},
    products = [],
    productsGrn = [],
    id = 0,
    currentUser,
    event,
  } = props
  const [selectedGrn, setSelectedGrn] = useState([] as SelectedProductsGrn[])
  const dispatch = useDispatch()

  const onUpdateGrn = (): void => {
    if (!validateGrns()) {
      message.error('ข้อมูล GRN สำหรับการตัดสินค้าออกจากสต๊อกไม่ถูกต้อง')
      return
    }
    const req: UpdateGrnReq = {
      decrease_stocks: formatProductGrnsReq(),
      id: id,
    }

    dispatch(updateGrnQuotationAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (!visible) return
    // default grn
    if (productsGrn) {
      const newSelect = [] as SelectedProductsGrn[]
      productsGrn.forEach(item => {
        let count = 0
        const target = [] as any[]
        const findProduct =
          products &&
          products.find(
            product =>
              product.product_id === item.product_id && product.product_option_id === item.product_option_id,
          )

        if (findProduct?.bom === 1) return
        const quantity = findProduct?.quantity_system || 0

        item?.product_grn_items &&
          item.product_grn_items.forEach(grn => {
            if (count > quantity) return
            if (grn.item.amount_system > 0) {
              target.push(grn.item.id)
              count += grn.item.amount_system
            }
          })
        newSelect.push({
          grn_item_ids: target,
          product_id: item.product_id,
          product_option_id: item.product_option_id,
          quantity: quantity,
        })
      })
      setSelectedGrn([...newSelect])
    }
  }, [productsGrn, visible])

  const renderInfo = (val: any) => {
    return <RowTile>{val}</RowTile>
  }

  const renderImage = (photo: any) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + photo} fallback={ImageFallback} />
  )

  const renderProductName = (item: string, record: QuotationProduct) => {
    const isSameTitle = record.title == record.product_option_title
    return (
      <>
        <RowTile>{record.title}</RowTile>
        {!isSameTitle && <ProductDesc>{record.product_option_title}</ProductDesc>}
        <OverstockTag isOverstock={record.sale_item_type === 'overstock'} />
      </>
    )
  }
  const renderProductUom = (item: string, record: QuotationProduct) => {
    return (
      <ProductUomSystemInfo
        multiplier={record.multiplier}
        quantity={record.quantity}
        uom={record.product_uom}
        quantitySystem={record.quantity_system}
        uomSystem={record.product_uom_system}
      />
    )
  }

  const renderTotalPrice = (item: string, record: QuotationProduct) => {
    return <TextRight>{numberWithComma((record.quantity || 0) * (record.price || 0), true)}</TextRight>
  }

  const getGrns = (product_id: number, product_option_id: number) => {
    const grns =
      productsGrn &&
      productsGrn.find(item => item.product_id === product_id && item.product_option_id === product_option_id)

    return grns ? grns.product_grn_items : []
  }

  const onSetSelectedGrn = (
    product_id: number,
    product_option_id: number,
    grn_item_ids: number[],
    quantity: number,
  ) => {
    const newSelect = [] as SelectedProductsGrn[]
    const hasProduct = cloneDeep(selectedGrn).find(
      item => item.product_id === product_id && item.product_option_id === product_option_id,
    )

    if (!_.isEmpty(hasProduct)) {
      selectedGrn.forEach(item => {
        if (item.product_id === product_id && item.product_option_id === product_option_id) {
          item.grn_item_ids = grn_item_ids
        }
        newSelect.push(item)
      })
    } else {
      newSelect.push({
        grn_item_ids: grn_item_ids,
        product_id: product_id,
        product_option_id: product_option_id,
        quantity: quantity,
      })
    }

    setSelectedGrn([...newSelect])
  }

  const getSelectedGrn = (product_id: number, product_option_id: number) => {
    const grns =
      selectedGrn &&
      selectedGrn.find(item => item.product_id === product_id && item.product_option_id === product_option_id)

    return grns ? grns.grn_item_ids : []
  }

  const getGrnIcon = (props: any) => {
    const { onExpand, record, expanded } = props
    if (!expanded) {
      onExpand(record, null)
    }
    return <Space direction="vertical" align="start"></Space>
  }

  const getGrnInfo = (record: QuotationProduct) => {
    const grnItems = getGrns(record.product_id, record.product_option_id) || []

    if (record?.sale_item_type === 'none-sku') {
      return <span>สินค้าที่ไม่มีในระบบ (None-SKU) คือ สินค้าที่ร้านค้าเพิ่มเอง</span>
    }

    if (record?.sale_item_type === 'overstock') {
      return (
        <span>
          ขายสินค้านอกสต๊อก คือ จำนวนสต๊อกสินค้าที่ทางร้านต้องการขายมากกว่าจำนวนสต๊อกที่มีในปัจจุบัน
          โดยระบบจะไม่นำจำนวนไปตัดสต๊อกที่มีในปัจจุบันของร้าน
        </span>
      )
    }

    if (record?.bom === 1) {
      return (
        <span>
          สินค้ามีส่วนประกอบ​ จะตัดสต๊อกของส่วนประกอบแบบเลือก GRN อัตโนมัติ
          โดยเรียงลำดับตามการนำสินค้าเข้าคลัง (First In, First Out)
        </span>
      )
    }

    return (
      <div>
        {/* <span>
          จำนวนที่ต้องตัดออกจากสต๊อก {record?.quantity_system || 0} {record?.product_uom_system || 0}
        </span> */}
        {grnItems && grnItems.length > 0 && (
          <Row>
            <Col span={24}>
              <GrnTransfer
                amount={record?.quantity_system || 0}
                uom={record?.product_uom_system || ''}
                productGrn={grnItems}
                onSetSelectedGrn={grn_item_ids =>
                  onSetSelectedGrn(
                    record.product_id,
                    record.product_option_id,
                    grn_item_ids,
                    record?.quantity_system || 0,
                  )
                }
                targetKeys={getSelectedGrn(record.product_id, record.product_option_id)}
              />
            </Col>
          </Row>
        )}
      </div>
    )
  }

  const formatProductGrnsReq = (): ProductGrns[] => {
    const req = [] as ProductGrns[]
    selectedGrn &&
      selectedGrn.forEach(item => {
        req.push({
          quantity: item.quantity,
          grn_item_ids: item.grn_item_ids,
        })
      })
    return req
  }

  const validateGrns = () => {
    let isValid = true
    //productsGrn
    selectedGrn &&
      selectedGrn.forEach(selected => {
        let count = 0
        const grnItem =
          productsGrn &&
          productsGrn.find(
            item =>
              item.product_id === selected.product_id &&
              item.product_option_id === selected.product_option_id,
          )

        if (grnItem) {
          grnItem.product_grn_items &&
            grnItem.product_grn_items.forEach(grn => {
              if (selected.grn_item_ids?.includes(grn.item.id)) {
                count += grn.item.amount_system
              }
            })
        }
        if (count < selected.quantity) {
          isValid = false
          return
        }
      })
    return isValid
  }

  const expandedContent = {
    expandedRowRender: getGrnInfo,
    fixed: 'left',
    expandIconColumnIndex: 0,
    defaultExpandAllRows: true,
    // eslint-disable-next-line react/display-name
    expandIcon: getGrnIcon,
    columnWidth: '0',
    childrenColumnName: `การตัดสินค้าออกจากสต๊อก`,
    showExpandColumn: true,
  }

  const columns = [
    {
      title: <ColTile>ลำดับ</ColTile>,
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return renderInfo(index + 1)
      },
      width: '50px',
    },
    {
      title: <ColTile>รูปภาพ</ColTile>,
      dataIndex: 'picture',
      key: 'picture',
      render: renderImage,
    },
    {
      title: <ColTile>รหัสสินค้า</ColTile>,
      dataIndex: 'code',
      key: 'code',
      render: (value: any) => renderInfo(value || '-'),
    },
    {
      title: <ColTile>รายการ</ColTile>,
      dataIndex: 'title',
      key: 'title',
      width: '200px',
      render: renderProductName,
    },
    {
      title: <ColTile>ยี่ห้อ</ColTile>,
      dataIndex: 'manufacture',
      key: 'manufacture',
      render: (value: any) => renderInfo(value || '-'),
    },
    {
      title: <ColTile>หน่วย</ColTile>,
      dataIndex: 'unit',
      key: 'unit',
      render: renderProductUom,
    },
    {
      title: <ColTile>จำนวน</ColTile>,
      dataIndex: 'quantity',
      key: 'quantity',
      render: (val: number) => numberWithComma(val),
    },
    {
      title: <ColTile>ราคาต่อหน่วย</ColTile>,
      dataIndex: 'price',
      key: 'price',
      render: (val: number) => numberWithComma(val, true),
    },
    {
      title: (
        <ColTile>
          <TextRight>ราคารวม</TextRight>
        </ColTile>
      ),
      dataIndex: 'total_discount',
      key: 'total_discount',
      render: renderTotalPrice,
    },
  ]

  const renderConfirmInfo = () => {
    return (
      <ConfirmWrapper>
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <Center>
              <Desc>กรุณาระบุหมายเลข GRN เพื่อนำสินค้าออกจากคลัง</Desc>
            </Center>
          </Col>
          <Col span={24}>
            <InfoValue>รายการสินค้า</InfoValue>
          </Col>
          <Col span={24}>
            <TableListPage
              rowKey="product_option_id"
              tableName="product-purchase"
              columns={columns}
              datas={products}
              size={'small'}
              scrollX={800}
              expandable={expandedContent}
            />
          </Col>
        </Row>
      </ConfirmWrapper>
    )
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onSuccess()
  }

  return (
    <>
      <ConfirmWithChild
        title={'ยืนยันสร้างรายการขาย'}
        isShow={visible}
        handleOk={onUpdateGrn}
        handleCancel={onCloseModal}
        child={renderConfirmInfo()}
        cancelBtnTxt="ปิด"
        confirmBtnTxt="ยืนยัน"
        width={'80%'}
      />
      <EventModal
        event={[event]}
        enable={visible}
        successCalback={onEventSuccess}
        errorCalback={clearEvent}
      />
    </>
  )
}

const Center = styled.div`
  text-align: center;
`

const ColTile = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const ConfirmWrapper = styled.div`
  padding: 10px;
  text-align: left;
`

const InfoValue = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const TextRight = styled.div`
  text-align: right;
  margin-right: 20px;
`

const Desc = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 70px;
  height: 70px;
  object-fit: cover;
`

const ProductDesc = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectGrnEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ConfirmQuotation)
